import { Sun, Moon } from "lucide-react";
import { useTheme } from "../lib/theme";

/**
 * ThemeToggle — small pill button that flips the site between light + dark modes.
 * Persists to localStorage. Respects OS preference on first visit.
 */
export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={isDark ? "Light mode" : "Dark mode"}
      className={`inline-flex items-center justify-center h-9 w-9 rounded-full border border-rule text-ink/70 hover:text-eucalypt hover:border-eucalypt/60 hover:-translate-y-0.5 transition-all ${className}`}
    >
      {isDark ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}
